module.exports = __webpack_public_path__ + "static/media/qr_code_blue.75c10c7b.png";